import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";

export type CoverageQueryParam =
  | ChildCoverageQueryParam
  | PregnantAndNewbornCoverageQueryParam
  | TravelCoverageQueryParam;

export enum TravelCoverageQueryParam {
  STANDARD = "STANDARD",
  SUPER = "SUPER",
}

export enum QueryParamNames {
  COVERAGE = "coverage",
  DAMAGE_RECENT_YEARS = "injuries",
  INJURY_YEAR = "injuryYear",
}

export enum TravelQueryParamNames {
  FAMILY_COVERAGE = "family",
}

export enum ChildQueryParamNames {
  CHILD_INDEX = "childIndex",
}

export interface TravelPriceQueryParams {
  readonly coverage: TravelCoverageQueryParam | null;
  readonly familyCoverage: boolean | null;
  readonly injuries: DamageRecentYears | null;
  readonly injuryYear: string | null;
}

export enum ChildCoverageQueryParam {
  BASIC = "BASIC",
  EXTRA = "EXTRA",
  TOTAL = "TOTAL",
}

export interface ChildDetailsQueryParams {
  readonly childIndex: number | null;
}

export enum PregnantAndNewbornCoverageQueryParam {
  PREGNANT = "PREGNANT",
  NEWBORN = "NEWBORN",
}

export enum SopSicknessLeaveQueryParamNames {
  DAILY_PAYOUT_AMOUNT = "dagpenger",
  REVENUE = "inntekt",
}

export interface SopSicknessLeaveQueryParams {
  readonly dailyPayoutAmount: number | null;
  readonly revenue: number | null;
}
